"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const getState_1 = require("../../../app/dist/getState");
const dist_1 = require("../../../fs/dist");
const dist_2 = require("../../../core/dist");
const dist_3 = require("../../../fs/dist");
const fs = __importStar(require("fs-extra"));
exports.toolDef = {
    name: 'loom_get_stale_plans',
    description: 'List all plans whose design_version is behind the current design version (i.e. the design was updated after the plan was created). These plans may need to be revised.',
    inputSchema: {
        type: 'object',
        properties: {},
        required: [],
    },
};
async function handle(root, _args) {
    const registry = new dist_3.ConfigRegistry();
    const state = await (0, getState_1.getState)({ getActiveLoomRoot: dist_1.getActiveLoomRoot, loadWeave: dist_1.loadWeave, buildLinkIndex: dist_1.buildLinkIndex, registry, fs, workspaceRoot: root });
    const results = state.weaves.flatMap(weave => (0, dist_2.getStalePlans)(weave).map(plan => {
        const thread = weave.threads.find(t => t.plans.some(p => p.id === plan.id));
        return {
            planId: plan.id,
            planTitle: plan.title,
            weaveId: weave.id,
            threadId: thread?.id,
            planDesignVersion: plan.design_version,
            currentDesignVersion: thread?.design?.version,
        };
    }));
    return { content: [{ type: 'text', text: JSON.stringify(results, null, 2) }] };
}
